import React, { ReactElement, ReactNode } from 'react';

export type JobsiteOverviewSectionProps = {
  label: ReactNode;
  children: ReactNode;
};

export function JobsiteOverviewSection({
  label,
  children,
}: JobsiteOverviewSectionProps): ReactElement {
  return (
    <div className="odin-flex odin-flex-col odin-gap-4">
      <span className="odin-text-sm odin-font-semibold odin-text-odin-navy">
        {label}
      </span>
      {children}
    </div>
  );
}
